import {
    GET_AFFILIATES_REQUEST,
    GET_AFFILIATES_REQUEST_SUCCESS,
    GET_AFFILIATES_REQUEST_FAILURE,
    COUNT_AFFILIATES,
} from '../constants/get_affiliates.constants';

import {
    UPDATE_AFFILIATE_REQUEST,
    UPDATE_AFFILIATE_REQUEST_SUCCESS,
    UPDATE_AFFILIATE_REQUEST_FAILURE,
} from '../../../Manage_affiliates_update/redux/constants/update_affiliate.constants';

const initialState = {
    loading: false,
    affiliates: [],
    current_affiliate: {},
    amount: 0,
    where: {
        name: undefined,
        old_crm_affiliate_id: undefined,
        loans_affiliate_id: undefined,
    },
    pagination: {
        page: 0,
        pageSize: 10,
    },
    error: null,
};

export const Manage_affiliates = (state = initialState, action) => {
    switch (action.type) {
    case GET_AFFILIATES_REQUEST:
        if (!action.pagination) {
            action.pagination = state.pagination;
        }
        if (!action.where) {
            action.where = state.where;
        }
        return {
            ...state,
            loading: true,
            pagination: { ...state.pagination, ...action.pagination },
            where: { ...state.where, ...action.where },
        };
    case GET_AFFILIATES_REQUEST_SUCCESS:
        return {
            ...state,
            affiliates: action.payload,
            loading: false,
        };
    case COUNT_AFFILIATES:
        return {
            ...state,
            amount: action.payload,
        };
    case 'RESET_AFFILIATE_DATA_WITH_FILTERS':
        return {
            ...state,
            loading: false,
            where: {
                name: undefined,
                old_crm_affiliate_id: undefined,
                loans_affiliate_id: undefined,
            },
            pagination: {
                page: 0,
                pageSize: 10,
            },
        };
    case 'SET_CURRENT_AFFILIATE':
        return {
            ...state,
            current_affiliate: action.payload,
        };
    case 'HANDLE_AFFILIATE_FIELDS':
        return {
            ...state,
            current_affiliate: {
                ...state.current_affiliate,
                name: action.name || (action.name === '' && []) || state.current_affiliate.name,
                abbr: action.abbr || (action.abbr === '' && []) || state.current_affiliate.abbr,
                old_crm_affiliate_id: action.old_crm_affiliate_id || (action.old_crm_affiliate_id === '' && []) || state.current_affiliate.old_crm_affiliate_id,
                loans_affiliate_id: action.loans_affiliate_id || (action.loans_affiliate_id === '' && []) || state.current_affiliate.loans_affiliate_id,
            },
        };
    case UPDATE_AFFILIATE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case UPDATE_AFFILIATE_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            affiliates: state.affiliates.map((affiliate) => {
                if (action.payload._id === affiliate._id) {
                    affiliate = action.payload;
                }
                return affiliate;
            }),
        };
    case GET_AFFILIATES_REQUEST_FAILURE:
    case UPDATE_AFFILIATE_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/redux/reducers/affiliates_list.reducers.js